import { AsyncPipe } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  Input,
  type OnChanges,
  type SimpleChanges,
} from '@angular/core';
import { SharedI18nModule } from '@bizzdesign/shared/i18n';
import { BadgeModule } from 'primeng/badge';
import { ButtonModule } from 'primeng/button';
import { TooltipModule } from 'primeng/tooltip';
import { MenuModule } from 'primeng/menu';
import { TranslateMenuItemsPipe } from '@bizzdesign/shared/pipes';
import { type BDMenuItem } from '@bizzdesign/shared/models';

@Component({
  selector: 'bd-account-notifications',
  imports: [
    AsyncPipe,
    BadgeModule,
    MenuModule,
    ButtonModule,
    TooltipModule,
    TranslateMenuItemsPipe,
    SharedI18nModule,
  ],
  templateUrl: './account-notifications.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AccountNotificationsComponent implements OnChanges {
  noNotifications = true;

  private noAccountNotifications: BDMenuItem[] = [
    {
      labelKey: 'accountNotifications.noNotifications',
      tScope: 'uiComponents',
      disabled: true,
    },
  ];

  @Input() accountNotificationsItems: BDMenuItem[] =
    this.noAccountNotifications;
  @Input() isFirstToolbarItem = false;

  ngOnChanges(changes: SimpleChanges) {
    if (changes['accountNotificationsItems']) {
      this.onAccountNotificationsItemsChange();
    }
  }

  private onAccountNotificationsItemsChange() {
    if (this.accountNotificationsItems?.length > 0) {
      this.noNotifications = false;
    } else {
      this.noNotifications = true;
      this.accountNotificationsItems = this.noAccountNotifications;
    }
  }
}
